export default __webpack_public_path__ + "static/media/dubai.ba80cdba.mp4";